export function isObject(item) {
  const plainObjectTypeString = Object.prototype.toString.call({});
  return Object.prototype.toString.call(item) === plainObjectTypeString;
}

/**
 * This method is similar to the `keyById` method but different in that it returns a
 * Javascript Map data structure.
 * One of the main benefits of using a map is:
 * A) It preserves INSERTION ORDER
 * B) With vue 3 and ref() we can have a reactive Map
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map
 * @see keyById
 *
 *
 * @param {Array} iterable
 * @param {{keyBy: String}} config
 */
export function toMap(iterable, config = {keyBy: 'id'}) {
  if (!Array.isArray(iterable)) throw new Error('right now you can only convert an array to a map');

  // If you give Map constructor array of arrays where each item in array is [key, value] you can use shorthand to create Map
  return new Map(iterable.map((value) => [value[config.keyBy], value]));
}

/**
 * Check if your javascript object is empty by checking if there are any keys in the object
 * @param obj the object to check
 * @return {boolean}
 */
export function isEmpty(obj) {
  return !obj || Object.keys(obj).length === 0;
}

export function isFunction(item) {
  return typeof item === 'function';
}

/**
 * Thin wrapper around Intl.ListFormat to humanize a list of items
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/ListFormat/ListFormat
 * returns "A, B, or C" etc
 *
 * @param {Array} list
 * @param {string} conjunction ['or', 'and']
 * @param {string} wrapper - a string to wrap the list in i.e. double quote " or single quote '
 * @return {string}
 */
export function humanizeList(list, {conjunction, wrapper} = {}) {
  if (!Array.isArray(list)) throw new Error('list must be an array');
  if (conjunction && !['or', 'and'].includes(conjunction)) throw new Error('conjunction if given must be "or" or "and"');

  let type = 'conjunction'; // and
  if (conjunction === undefined) {
    type = 'unit';
  } else if (typeof conjunction === 'string' && conjunction.toLowerCase() === 'or') {
    type = 'disjunction'; // or
  }

  const style = 'long',
        formatter = new Intl.ListFormat('en', {style, type});

  if (wrapper && typeof wrapper === 'string') {
    return `${wrapper}${formatter.formatToParts(list).map((x) => x.value).join(wrapper)}${wrapper}`;
  }
  return formatter.format(list);
}
